import { useState } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { apiErrorMessage, useAuth } from "@/AuthContext";
import { LOGIN } from "@/constants/testIds/auth";
import PublicFooter from "@/components/PublicFooter";

export default function LoginPage() {
  const { user, loading, login } = useAuth();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (!loading && user) {
    const from = location.state?.from;
    const dest = user.role === "admin"
      ? "/admin"
      : user.has_access !== true
        ? "/billing?subscribe=1"
        : (typeof from === "string" && from.startsWith("/") ? from : "/dashboard");
    return <Navigate to={dest} replace />;
  }

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(apiErrorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mp-auth">
      <div className="mp-auth-card">
        <p className="mp-kicker">MinutePay</p>
        <h1>Sign in</h1>
        <p className="mp-lead">Track interpreter income. Your license is managed here.</p>
        <form onSubmit={onSubmit} className="mp-form">
          <label>
            Email
            <Input
              data-testid={LOGIN.emailInput}
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
            />
          </label>
          <label>
            Password
            <Input
              data-testid={LOGIN.passwordInput}
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </label>
          {error ? <p className="mp-error">{error}</p> : null}
          <Button data-testid={LOGIN.submitButton} type="submit" disabled={busy} className="w-full">
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>
        <p className="mp-switch">
          <Link data-testid={LOGIN.forgotPasswordLink} to="/forgot-password">
            Forgot password?
          </Link>
        </p>
        <p className="mp-switch">
          New here?{" "}
          <Link data-testid={LOGIN.registerLink} to="/register">
            Create an account
          </Link>
        </p>
      </div>
      <PublicFooter />
    </div>
  );
}
